var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('time',{staticClass:"ucl-quiz-timer",attrs:{"datetime":_setup.formatSecondsToIso(_setup.seconds),"role":"timer","aria-label":"Eltelt idő","data-test-id":"timer"}},[_vm._v("\n\t"+_vm._s(_setup.formatSeconds(_setup.seconds))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }